import { render, staticRenderFns } from "./LabelDrawer.vue?vue&type=template&id=8bd58c92&scoped=true&"
import script from "./LabelDrawer.vue?vue&type=script&lang=ts&"
export * from "./LabelDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./LabelDrawer.vue?vue&type=style&index=0&id=8bd58c92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd58c92",
  null
  
)

export default component.exports